// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserSlash } from '@fortawesome/pro-solid-svg-icons';

// Components
import StateScreen from './StateScreen';

/**
 * @function ErrorNoToken
 * Describe the component's function
 *
 * @example
 * return (
 *   <ErrorNoToken />
 * )
 */
function ErrorNoToken(): JSX.Element {
    return (
        <StateScreen
            icon={<FontAwesomeIcon icon={faUserSlash} />}
            title="Sorry, we can't identify you"
        >
            <p>
                Please{' '}
                <a href="https://www.bingoport.com">login to Bingoport</a> and
                choose Play Bingo from the main menu.
            </p>
        </StateScreen>
    );
}

// Exports
export default ErrorNoToken;
